import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaArrowUp } from "react-icons/fa";

const GOLD = "#C9A84C";
const DARK = "#2A2E3A";

export default function ScrollProgress() {
  const [progress, setProgress] = useState(0);
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrolled = window.scrollY;
      const total = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(total > 0 ? (scrolled / total) * 100 : 0);
      setShowTop(scrolled > 300);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
      {/* Gold progress bar at top */}
      <div
        className="fixed top-0 left-0 z-[200] h-0.5 transition-none"
        style={{ width: `${progress}%`, background: `linear-gradient(90deg, ${GOLD}, #e8c56d)` }}
      />

      {/* Back-to-top button */}
      <AnimatePresence>
        {showTop && (
          <motion.button
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            onClick={scrollToTop}
            className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 w-10 h-10 rounded-full flex items-center justify-center shadow-xl transition-transform hover:scale-110"
            style={{ background: GOLD, color: DARK }}
            aria-label="Retour en haut"
          >
            <FaArrowUp size={14} />
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
}
